<template>
  <div class="header" :class="{ 'hide': hide}">
    <van-row justify="center">
      <!-- 链选择下拉框 -->
      <van-col span="8">
        <van-dropdown-menu>
          <van-dropdown-item 
            v-model="currentChain" 
            :options="chainOptions"
            @change="handleChainChange"
          >
            <template #title>
              <div class="dropdown-title">
                <img :src="getChainImg(currentChain)" class="chain-icon hide"/>
                {{ getChainTitle(currentChain) }}
              </div>
            </template>
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-col>

      <!-- 标题 -->
      <van-col span="8">
        <div class="header__item">
          {{ $t("home page") }}
        </div>
      </van-col>

      <!-- 语言选择下拉框 -->
      <van-col span="8">
        <van-dropdown-menu>
          <van-dropdown-item 
            v-model="currentLang" 
            :options="langOptions"
            @change="handleLangChange"
          >
            <template #title>
              <div class="dropdown-title">
                <img :src="getLangImg(currentLang)" class="lang-icon hide" />
                {{ getLangTitle(currentLang) }}
              </div>
            </template>
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-col>
    </van-row>
  </div>

    <div v-if="ifshow" class="mydunhuans">
        <div>
        <span>{{ $t("Please connect your wallet first") }}</span>
        </div>
    </div>
</template>
<script>
import walletMixin from '@/mixin/wallet';
import { mapState, mapActions } from "vuex";

export default {
  name: 'DfUi2Header',
  props: {
    hide: {
      type: Boolean,
      default: false, // 起始值
    },
  },
  mixins: [walletMixin],
  data() {
    return {
      baseURL: this.$config.BASE_URL, // 使用配置的 baseURL
      ifshow: false,

      // 当前选中的链和语言
      currentChain: 'erc',
      currentLang: 'en',
      CHAIN_LIST: this.$config.CHAIN_LIST,
      LANG_LIST: this.$config.LANG_LIST,
    };
  },
  computed: {
    ...mapState(['address', 'chain', 'lang', 'invite_code', 'kefu']),

    chainOptions() {
      return Object.values(this.CHAIN_LIST).map(item => ({
        text: item.title,
        value: item.id
      }))
    },
    
    langOptions() {
      return Object.values(this.LANG_LIST).map(item => ({
        text: item.title,
        value: item.id
      }))
    }
  },
  watch() { },
  methods: {
    ...mapActions(["connectWallet", "updateChain", "updateLang", "updateState"]),
    

    // 获取链图标
    getChainImg(chainId) {
      return this.CHAIN_LIST[chainId]?.img || ''
    },
    
    // 获取链标题
    getChainTitle(chainId) {
      return this.CHAIN_LIST[chainId]?.title || ''
    },
    
    // 获取语言图标
    getLangImg(langId) {
      return this.LANG_LIST[langId]?.img || ''
    },
    
    // 获取语言标题
    getLangTitle(langId) {
      return this.LANG_LIST[langId]?.title || ''
    },
    
    // 链选择变化
    async handleChainChange(chainId) {
      this.updateChain(chainId)
      this.$api.users.info();//切换链---获取并设置用户信息
    },
    
    // 语言选择变化
    handleLangChange(langId) {
      console.log('语言切换至:', langId)
      this.updateLang(langId)
      this.$i18n.locale = langId // 假设使用vue-i18n
      // 可以添加其他语言切换逻辑
    }
  },
  mounted() {
    console.log('=========app-mounted=========')
    this.currentLang = this.lang || 'en'; // 默认语言
    this.currentChain = this.chain || 'erc'; // 默认链

    //获取基础信息
    this.$api.index.init();
    //启动APP链接钱包，并尝试更新用户信息
    this.connectWallet().then(res => {
      console.log('链接钱包:', res)
      if (res.success) {
        this.$api.users.info();//初始化app-链接钱包，获取并设置用户信息
      }
    })

    if (this.$getters.address) {
      this.ifshow = false;
    }

    //邀请码
    let url = window.location.href;
    let cs = url.split("=")[1] ?? '';
    if (cs > 0) {
      this.updateState({ key: 'invite_code', value: cs })
    }
    //this.debug_login()
  },
};
</script>
<style scoped lang="scss">

.header { 
  width: 100%;
  height: 58px;
  background-color: rgba(0, 0, 0, 0);
  .header__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 58px;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
  }
}


.dropdown-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
}

.chain-icon, .lang-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* 自定义下拉菜单样式 */
:deep(.van-dropdown-menu__bar) {
  background-color: transparent;
  box-shadow: none;
}

:deep(.van-dropdown-menu) {
  height: 58px;
  line-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.van-dropdown-item__option) {
  text-align: left;
  padding-left: 20px;
}

.mydunhuans {
  z-index: 999;
  position: fixed;
  /* 居中 */
  top: 50%;
  bottom: 100px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 10%;
  background-color: #fff;
  border-radius: 20px;
  background-color: rgba(34, 32, 32, 0.8);
  justify-content: center;
  align-content: center;
  display: flex;

  overflow-y: auto;
  -ms-overflow-style: none;
  --tw-gradient-from: #0993ec;
  --tw-gradient-stops: var(--tw-gradient-from), #f338c3, rgba(9, 147, 236, 0);
  --tw-gradient-from: #0993ec;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(9, 147, 236, 0));
  --tw-gradient-to: #f338c3;
  background-image: linear-gradient(90deg, var(--tw-gradient-stops));
  /* 字居中 */
}

.mydunhuans div {
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>